/**
 * DinheiroModal Component
 * 
 * Modal específico para criar/editar forma de recebimento do tipo Dinheiro.
 */

import { useState, useEffect } from 'react'
import Modal from '../../../../../components/ERP/Modal/Modal'
import FormField from '../../../../../components/ERP/Form/FormField'
import { DollarSign } from 'lucide-react'

function DinheiroModal({ isOpen, onClose, onSubmit, editingForma, accounts, errors }) {
  console.log('DinheiroModal renderizado, isOpen:', isOpen, 'editingForma:', editingForma)
  
  const [formData, setFormData] = useState({
    name: 'Dinheiro',
    description: '',
    accountId: '',
    active: true
  })

  useEffect(() => {
    console.log('DinheiroModal useEffect, isOpen:', isOpen, 'editingForma:', editingForma)
    if (editingForma) {
      setFormData({
        name: editingForma.name || 'Dinheiro',
        description: editingForma.description || '',
        accountId: editingForma.account_id || '',
        active: editingForma.active !== undefined ? editingForma.active : true
      })
    } else {
      setFormData({
        name: 'Dinheiro',
        description: '',
        accountId: '',
        active: true
      })
    }
  }, [editingForma, isOpen])

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit({
      ...formData,
      provider: 'DINHEIRO',
      paymentType: 'DINHEIRO',
      taxRate: 0,
      installments: null,
      cardBrand: null,
      requiresConfirmation: false
    })
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editingForma ? 'Editar Dinheiro' : 'Nova Forma: Dinheiro'}
      icon={<DollarSign size={24} />}
      size="medium"
      footer={
        <>
          <button
            className="btn-secondary"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            className="btn-primary"
            onClick={handleSubmit}
          >
            {editingForma ? 'Salvar' : 'Criar'}
          </button>
        </>
      }
    >
      <form onSubmit={handleSubmit}>
        <FormField
          label="Nome"
          name="name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          error={errors.name}
          required
          placeholder="Ex: Dinheiro"
        />

        <FormField
          label="Descrição"
          name="description"
          type="textarea"
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          error={errors.description}
          placeholder="Descrição opcional"
        />

        <FormField
          label="Conta Financeira"
          name="accountId"
          type="select"
          value={formData.accountId}
          onChange={(e) => setFormData({ ...formData, accountId: e.target.value })}
          error={errors.accountId}
          options={[
            { value: '', label: 'Selecione uma conta...' },
            ...accounts.map(account => ({
              value: account.id.toString(),
              label: `${account.code} - ${account.name}`
            }))
          ]}
        />

        <FormField
          label="Status"
          name="active"
          type="select"
          value={formData.active ? 'true' : 'false'}
          onChange={(e) => setFormData({ ...formData, active: e.target.value === 'true' })}
          error={errors.active}
          options={[
            { value: 'true', label: 'Ativa' },
            { value: 'false', label: 'Inativa' }
          ]}
        />

        {errors.submit && (
          <div className="form-error-message">{errors.submit}</div>
        )}
      </form>
    </Modal>
  )
}

export default DinheiroModal
